// src/router/routes.js

import { ROLES } from "@/constants";
import Vertical from "@/layouts/vertical";
import authRoutes from "./auth";
import accountRoutes from "./facility-account";
import errorRoutes from "./error";

export default [
  ...authRoutes,
  ...errorRoutes,
  {
    path: "/admin",
    component: Vertical,
    meta: { authRequired: true },
    children: [
      ...accountRoutes,
      {
        path: "/admin/profile",
        name: "profile",
        component: () => import("@/views/auth/profile"),
        meta: {
          title: "Profile",
          authRequired: true
        },
      },
      {
        path: "",
        name: "default",
        meta: {
          title: "Dashboard",
          authRequired: true,
          roles: [ROLES.FACILITY_MANAGER, ROLES.FACILITY_ACCOUNT],
        },
        component: () => import("../views/dashboard/index.vue"),
      },
      {
        path: "setting/facility-info-management",
        name: "facility-info-management",
        meta: {
          title: "Facility Info Management",
          roles: [ROLES.FACILITY_MANAGER, ROLES.FACILITY_ACCOUNT],
        },
        component: () => import("../views/setting/facility-management/index.vue"),
      },
      {
        path: "setting/user-management-by-admin",
        name: "user-management-by-admin",
        meta: {
          title: "User Management",
          roles: [ROLES.ADMIN],
        },
        component: () => import("../views/setting/user-management/admin-manager/index.vue"),
      },
      {
        path: "setting/user-management-by-admin/tablet",
        name: "user-management-by-admin-tablet",
        meta: {
          title: "User tablet Management",
          roles: [ROLES.ADMIN],
        },
        component: () => import("../views/setting/user-management/admin-manager/User-tablet.vue"),
      },
      {
        path: "setting/user-management-by-admin/create",
        name: "admin-create-user",
        meta: {
          title: "Create User By Admin",
          roles: [ROLES.ADMIN],
        },
        component: () => import("../views/setting/user-management/admin-manager/create/index.vue"),
      },
      {
        path: "setting/user-management-by-admin/:userId",
        name: "admin-update-user",
        meta: {
          title: "Update User By Admin",
          roles: [ROLES.ADMIN],
        },
        component: () => import("../views/setting/user-management/admin-manager/update/index.vue"),
      },
      {
        path: "setting/user-management-by-facility-manager/:userId",
        name: "facility-manager-update-user",
        meta: {
          title: "Update User By Facility Manager",
          roles: [ROLES.FACILITY_MANAGER],
        },
        component: () => import("../views/setting/facility-manager/update/index.vue"),
      },
      {
        path: "setting/user-management-by-facility-manager/create",
        name: "facility-manager-create-user",
        meta: {
          title: "Create User By Facility Manager",
          roles: [ROLES.FACILITY_MANAGER],
        },
        component: () => import("../views/setting/facility-manager/create/index.vue"),
      },
      {
        path: "setting/user-management-by-facility-manager",
        name: "facility-manager-user-list",
        meta: {
          title: "List user by facility manager",
          roles: [ROLES.FACILITY_MANAGER],
        },
        component: () => import("../views/setting/facility-manager/index.vue"),
      },
      {
        path: "facility/list",
        name: "admin-facility-list",
        meta: {
          title: "List facility",
          roles: [ROLES.ADMIN],
        },
        component: () => import("../views/setting/admin-management/facilities/index.vue"),
      },
      {
        path: "facility/:facilityId",
        name: "facility-update-management",
        meta: {
          title: "Facility Info Management",
          roles: [ROLES.FACILITY_MANAGER, ROLES.ADMIN],
        },
        component: () => import("../views/setting/admin-management/facilities/Update.vue"),
      },
      {
        path: "facility-app/:facilityId",
        name: "facility-update-app-management",
        meta: {
          title: "Facility Info Management",
          roles: [ROLES.ADMIN],
        },
        component: () => import("../views/setting/admin-management/tablet-facilities/Update.vue"),
      },
      {
        path: "facility/create",
        name: "facility-create-management",
        meta: {
          title: "Facility Info Management",
          roles: [ROLES.FACILITY_MANAGER, ROLES.ADMIN],
        },
        component: () => import("../views/setting/admin-management/facilities/Create.vue"),
      },
      {
        path: "setting/advertisement-management",
        name: "advertisement-management",
        meta: {
          title: "Advertising management",
          roles: [ROLES.FACILITY_MANAGER, ROLES.ADMIN],
        },
        component: () => import("../views/setting/ads-management/index.vue"),
      },
      {
        path: "setting/advertisement-history",
        name: "advertisement-history",
        meta: {
          title: "Advertising history",
          roles: [ROLES.FACILITY_MANAGER, ROLES.ADMIN],
        },
        component: () => import("../views/setting/ads-management/history/index.vue"),
      },
      {
        path: "play-discs",
        name: "play-discs-management",
        meta: {
          title: "Play dist management",
          roles: [ROLES.FACILITY_MANAGER, ROLES.ADMIN],
        },
        component: () => import("../views/setting/admin-management/play-dist/index.vue"),
      },
      {
        path: "play-discs/create",
        name: "play-discs-create",
        meta: {
          title: "Play dist create",
          roles: [ROLES.FACILITY_MANAGER, ROLES.ADMIN],
        },
        component: () => import("../views/setting/admin-management/play-dist/create.vue"),
      },
      {
        path: "play-discs/:playlistId",
        name: "play-discs-update",
        meta: {
          title: "Play dist update",
          roles: [ROLES.FACILITY_MANAGER, ROLES.ADMIN],
        },
        component: () => import("../views/setting/admin-management/play-dist/create.vue"),
      },
      {
        path: "setting/upload-facility-list",
        name: "upload-facility-list",
        meta: {
          title: "Upload facility list",
          roles: [ROLES.ADMIN],
        },
        component: () => import("../views/setting/admin-management/upload-facility-list/index.vue"),
      },
      {
        path: "setting/system-management",
        name: "system-management",
        meta: {
          title: "System management",
          roles: [ROLES.ADMIN],
        },
        component: () => import("../views/setting/system-management/index.vue"),
      },
      {
        path: "setting/sns",
        name: "sns-setting",
        meta: {
          title: "SNS Setting",
          roles: [ROLES.FACILITY_MANAGER, ROLES.FACILITY_ACCOUNT],
        },
        component: () => import("../views/sns/setting/index.vue"),
      },
      {
        path: "setting/coupon",
        name: "coupon_list",
        meta: {
          title: "Coupon Setting",
          roles: [ROLES.FACILITY_MANAGER, ROLES.FACILITY_ACCOUNT],
        },
        component: () => import("../views/coupon/index.vue"),
      },
      {
        path: "setting/coupon/:couponId",
        name: "coupon_update",
        meta: {
          title: "Coupon Update",
          roles: [ROLES.FACILITY_MANAGER],
        },
        component: () => import("../views/coupon/update/index.vue"),
      },
      {
        path: "setting/coupon/create",
        name: "coupon_create",
        meta: {
          title: "Coupon Create",
          roles: [ROLES.FACILITY_MANAGER],
        },
        component: () => import("../views/coupon/create/index.vue"),
      },
      {
        path: "setting/facilities/application",
        name: "facilities-management-by-admin",
        meta: {
          title: "User Management",
          roles: [ROLES.ADMIN],
        },
        component: () => import("../views/setting/admin-management/tablet-facilities/index.vue"),
      },
      {
        path: "setting/upload-images",
        name: "admin-upload-images",
        meta: {
          title: "Upload images",
          roles: [ROLES.ADMIN],
        },
        component: () => import("../views/setting/admin-management/upload-images/UploadImage.vue"),
      },
      {
        path: "staff-management/shift-form",
        name: "shift-form",
        meta: {
          title: "Shift Management",
          roles: [ROLES.FACILITY_MANAGER, ROLES.FACILITY_ACCOUNT],
        },
        component: () => import("../views/timesheet/calendar.vue"),
      },
      {
        path: "staff-management/record-chart",
        name: "record-chart",
        meta: {
          title: "Record Chart",
          roles: [ROLES.FACILITY_MANAGER, ROLES.FACILITY_ACCOUNT],
        },
        component: () => import("../views/timesheet/index.vue"),
      },
      {
        path: "setting/publicApi",
        name: "publicApi-management",
        meta: {
          title: "Public API",
          roles: [ROLES.ADMIN],
        },
        component: () => import("../views/setting/public-api/index.vue"),
      },
      {
        path: "notification",
        name: "notification-management",
        meta: {
          title: "Notification management",
          roles: [ROLES.ADMIN, ROLES.FACILITY_MANAGER, ROLES.FACILITY_ACCOUNT],
        },
        component: () => import("../views/setting/admin-management/push-notification/index.vue"),
      },
      {
        path: "setting-alert",
        name: "setting-alert",
        meta: {
          title: "Setting alert",
          roles: [ROLES.FACILITY_MANAGER, ROLES.FACILITY_ACCOUNT],
        },
        component: () => import("../views/setting/facility-management/alert-setting/index.vue"),
      },
      {
        path: "holidays",
        name: "setting-holidays",
        meta: {
          title: "Setting holidays",
          roles: [ROLES.ADMIN],
        },
        component: () => import("../views/setting/holiday-management/index.vue"),
      },
    ],
  },
  {
    path: "/sns/:id",
    name: "sns",
    meta: {
      title: "SNS",
      authRequired: false,
    },
    component: () => import("../views/sns/public/index.vue"),
  },
];
